//
//
//
//
//
//

import { scrollTo } from "@/utils/scroll-to";
export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 40, 50, 100];
      }
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageNum: {
      get() {
        return this.currentPage;
      },
      set(val) {
        this.$emit("update:currentPage", val);
      }
    },
    limit: {
      get() {
        return this.pageSize;
      },
      set(val) {
        this.pageNum = 1;
        this.$emit("update:pageSize", val);
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", {
        currentPage: this.pageNum,
        pageSize: val
      });
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    },
    handleCurrentChange(val) {
      this.$emit("pagination", {
        currentPage: val,
        pageSize: this.limit
      });
      if (this.autoScroll) {
        scrollTo(0, 800);
      }
    }
  }
};